import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import './style.scss';

const NavBar = (props) => {
  const {
    isLoggedIn,
    history,
    history: {
      location: {
        pathname,
      },
    },
    signOut,
  } = props;

  const _signOut = () => {
    signOut();

    // send home if on profile page
    if (pathname === '/profile') {
      history.push('/');
    }
  };

  return (
    <header>
      <nav className="bar">
        <div>
          <NavLink className="logolink" to="/" exact>MyBallot</NavLink>
        </div>
        <div className="minibox">
          <NavLink className="link" to="/elections" exact>Discover Elections</NavLink>
          {isLoggedIn && <NavLink className="link" to="/my-elections" exact>My Elections</NavLink>}
          <NavLink className="link" to="/quiz" exact>Take Our Quiz</NavLink>
          <NavLink className="link" to="/turnout" exact>Turnout Data</NavLink>
          <NavLink className="link" to="/roles" exact>Learn About Roles</NavLink>
          {isLoggedIn
            ? (
              <>
                <NavLink className="link" to="/profile" exact>Profile</NavLink>
                <button type="button" onClick={_signOut}>Sign Out</button>
              </>
            )
            : <NavLink className="link" to="/login" exact>Login</NavLink>
          }
        </div>
      </nav>
    </header>
  );
};

export default withRouter(NavBar);
